import { FETCH_GET } from "../../config";

export const GET_SETTING_PENDING = "GET_SETTING_PENDING";
export const GET_SETTING_FULFILLED = "GET_SETTING_FULFILLED";
export const GET_SETTING_REJECTED = "GET_SETTING_REJECTED";

export const getSettingData = () => {
  const query = `query={getSettingData{id,title,description,keywords,logo,phone,free_shipping,facebook,instagram,copyright,footer_info,footer_mail,footer_phone,footer_address,shipping_cost,payments{method,successMessage,content},annocoment{bg,color},wpTitle,wpContent,wpPhone,cartPosition}}`;
  return async (dispatch) => {
    dispatch({ type: GET_SETTING_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: GET_SETTING_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: GET_SETTING_FULFILLED,
          payload: result.data.data.getSettingData,
        });
      }
    } catch (e) {
      dispatch({ type: GET_SETTING_REJECTED });
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/setting.js